import React, { lazy } from 'react'

import * as Sentry from '@sentry/react'
import { createBrowserRouter } from 'react-router-dom'

import { BetaTestProvider } from '@app/providers/BetaTestProvider'
import {
  DownloadAppRoute,
  ErrorRoute,
  InvitationByEmailInfoPageRoute,
  InvitationByEmailPageRoute,
  InvitationByMailRoute,
  InvitationExpiredRoute,
  LandingPageRoute,
  SendNewInvitationRoute,
} from '@app/routes'

const ErrorPage = lazy(() =>
  import('@app/pages/ErrorPage').then((module) => ({
    default: module.ErrorPage,
  })),
)
const AppLayoutTwoColumns = lazy(() =>
  import('@app/layout/AppLayoutTwoColumns').then((module) => ({
    default: module.AppLayoutTwoColumns,
  })),
)
const LayoutTwoColumns = lazy(() =>
  import('@app/layout/LayoutTwoColumns').then((module) => ({
    default: module.LayoutTwoColumns,
  })),
)
const BetaLayout = lazy(() =>
  import('@app/layout/BetaLayout').then((module) => ({
    default: module.BetaLayout,
  })),
)
const LandingPage = lazy(() =>
  import('@app/pages/LandingPage').then((module) => ({
    default: module.LandingPage,
  })),
)
const InvitationPage = lazy(() =>
  import('@app/pages/InvitationPage').then((module) => ({
    default: module.InvitationPage,
  })),
)
const InvitationByEmailInfoPage = lazy(() =>
  import('@app/pages/InvitationByEmailInfoPage').then((module) => ({
    default: module.InvitationByEmailInfoPage,
  })),
)
const InvitationByMailPage = lazy(() =>
  import('@app/pages/InvitationByMailPage').then((module) => ({
    default: module.InvitationByMailPage,
  })),
)
const SendNewInvitationPage = lazy(() =>
  import('@app/pages/SendNewInvitationPage').then((module) => ({
    default: module.SendNewInvitationPage,
  })),
)
const InvitationExpiredPage = lazy(() =>
  import('@app/pages/InvitationExpiredPage').then((module) => ({
    default: module.InvitationExpiredPage,
  })),
)
const DownloadAppPage = lazy(() =>
  import('@app/pages/DownloadAppPage').then((module) => ({
    default: module.DownloadAppPage,
  })),
)
const NotFoundPage = lazy(() =>
  import('@app/pages/NotFoundPage').then((module) => ({
    default: module.NotFoundPage,
  })),
)

export const router = createBrowserRouter([
  {
    path: LandingPageRoute,
    element: (
      <Sentry.ErrorBoundary
        fallback={
          <AppLayoutTwoColumns>
            <ErrorPage />
          </AppLayoutTwoColumns>
        }
      >
        <LayoutTwoColumns />
      </Sentry.ErrorBoundary>
    ),
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: InvitationByEmailInfoPageRoute,
        element: <InvitationByEmailInfoPage />,
      },
      {
        path: InvitationByMailRoute,
        element: <InvitationByMailPage />,
      },
      {
        path: SendNewInvitationRoute,
        element: <SendNewInvitationPage />,
      },
      {
        path: InvitationExpiredRoute,
        element: <InvitationExpiredPage />,
      },
      {
        path: ErrorRoute,
        element: <ErrorPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
  {
    path: LandingPageRoute,
    element: (
      <Sentry.ErrorBoundary
        fallback={
          <AppLayoutTwoColumns>
            <ErrorPage />
          </AppLayoutTwoColumns>
        }
      >
        <BetaTestProvider token="invitations">
          <BetaLayout />
        </BetaTestProvider>
      </Sentry.ErrorBoundary>
    ),
    children: [
      {
        path: InvitationByEmailPageRoute,
        element: <InvitationPage />,
      },
      {
        path: DownloadAppRoute,
        element: <DownloadAppPage />,
      },
    ],
  },
])
